import { render, staticRenderFns } from "./OrderTGInfo.vue?vue&type=template&id=87263034&scoped=true&"
import script from "./OrderTGInfo.vue?vue&type=script&lang=js&"
export * from "./OrderTGInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderTGInfo.vue?vue&type=style&index=0&id=87263034&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87263034",
  null
  
)

export default component.exports